export const processingOverlayMessagesEn = {
  'dataExploration.processingOverlay.spinnerTitle': 'Generating event data',
  'dataExploration.processingOverlay.message': 'This may take a few moments',
  'dataExploration.processingOverlay.messageStillProcessing': 'Still processing...',
  'dataExploration.processingOverlay.messageLong':
    'This is taking longer than usual, but processing is still running',
};
